import { IConfiguratorHistoryUpdater, TValidOptionValues } from "../types";
import { Variant } from "../../../../Interfaces/Product";
import { KEEP_SEARCH_PARAMS } from "../Constants";

export class ConfigHistory implements IConfiguratorHistoryUpdater {
    private popStateCallback: (e: PopStateEvent) => void;

    constructor(variant: Variant, validValues: TValidOptionValues) {
        window.addEventListener("popstate", (e) => {
            if ("function" === typeof this.popStateCallback) {
                this.popStateCallback(e);
            }
        });
        this.replace(variant, validValues);
    }

    public push(variant: Variant, validValues: TValidOptionValues): void {
        history.pushState({ variant, validValues }, "", this.getUrl(variant));
    }

    public replace(variant: Variant, validValues: TValidOptionValues): void {
        history.replaceState({ variant, validValues }, "", this.getUrl(variant));
    }

    public set onPopState(cb: typeof this.popStateCallback) {
        this.popStateCallback = cb;
    }

    protected getUrl(variant: Variant): string {
        if (KEEP_SEARCH_PARAMS && this.searchParams !== "") {
            return `${location.pathname}?variant=${variant.id}&${this.searchParams}`;
        }
        return `${location.pathname}?variant=${variant.id}`;
    }

    public get searchParams(): string {
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete("variant");
        return searchParams.toString();
    }
}
